import type { Element, MouseEventHandler } from "React";
import React from "react";
import { FormattedMessage } from "react-intl";
import ReactTooltip from "react-tooltip";
import CopyIcon from "./copy.png";

type Props = {
  onClick: MouseEventHandler;
};

const IconCopy = (props: Props): Element<"img"> => (
  <React.Fragment>
    <img
      src={CopyIcon}
      alt="Copy"
      className="icon-copy"
      onClick={props.onClick}
      data-tip
      data-for="copyMessage"
    />
    <ReactTooltip
      id="copyMessage"
      event="click"
      eventOff="mouseout"
      place="top"
      type="dark"
      isCapture={true}
    >
      <FormattedMessage tagName="span" id="clipboard-copy-message" />
    </ReactTooltip>
  </React.Fragment>
);

export default IconCopy;
